export default (ctx: any) => (
  [
    {
      title: ctx.t('Campaigns'),
      value: 'campaigns',
      fieldName: 'campaigns-name',
      data: <any[]> [],
    },
    {
      title: ctx.t('Traffic sources'),
      value: 'traffic-sources',
      fieldName: 'traffic_sources-name',
      data: <any[]> [],
    },
    {
      title: ctx.t('Countries'),
      value: 'countries',
      fieldName: 'reports-country',
      data: <any[]> [],
    },
    {
      title: ctx.t('Offers'),
      value: 'offers',
      fieldName: 'offers-name',
      data: <any[]> [],
    }
  ]
);